import { render, staticRenderFns } from "./ContactRelationshipForm.vue?vue&type=template&id=1d2922cc"
import script from "./ContactRelationshipForm.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports